// extracted by mini-css-extract-plugin
module.exports = {"paymentForm":"PaymentDialog_paymentForm__1W9Ez"};